import type { Schema } from './types'

export const shared: Schema = {
  'account-show-work-button': {
    default: false,
  },
  'account-bulk-address-upload': {
    default: true,
  },
  'customer-new-order-details-enabled': {
    default: true,
  },
  'customer-self-serve-credit': {
    default: false,
  },
  'moonpig-plus-cancellation-contact-question': {
    default: false,
  },
  'show-mail-strike-alert': {
    default: false,
  },
  'show-saved-cards': {
    default: false,
  },
  'enable-fav-toast-notification': {
    default: false,
  },
  'show-business-orders-view': {
    default: false,
  },
}
